import { useMutation } from "urql";

import { ApproveTransactionHistoryDocument } from "../../../graphql/generated.ts";

export const useApproveTransactionHistory = () =>
  useMutation(ApproveTransactionHistoryDocument);
